import { API_URL } from '../../../../utils/config';

export const DELETE_STATIC_IP_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
export const EDIT_STATIC_IP_URL = `https://slot.tizeti.com//geniatechapi/index.php`;
export const ADD_STATIC_IP_URL = `${API_URL}/geniatech/add_ip`;
